export default __webpack_public_path__ + "static/media/IinkOpenNewWindow.e8cb3688.svg";